import $foreign from "./foreign.cjs";
var reallyUnsafeRefEq = $foreign.reallyUnsafeRefEq;
export { reallyUnsafeRefEq };
